import requests from "./request";

// 请求菜单
export const reqgetCategoryList = () => requests.get('/category/all');

// 请求滑动标题及图片
export const reqSliderList = () => requests.get('/slider/children/2');

// 联盛浆纸公司介绍
export const reqgetCompanyLsjz = () => requests.get('article/company/2');

// 联盛纸业公司介绍
export const reqgetCompanyLszy = () => requests.get('article/company/1');

// 联盛浆纸大事记
export const reqgetHistoryLsjz = () => requests.get('article/children/6');

// 四大产品介绍
export const reqgetProducts = () => requests.get('product/children/1');

// 新闻动态
export const reqgetNewsInfo = (pageNum, pageSize) => {
  // 使用反引号（`）来定义模板字符串，并可以在其中嵌入变量  
  return requests.get(`/info/table?pageNum=${pageNum}&pageSize=${pageSize}`);
};
// 热点新闻
export const reqgetHotNewsInfo = () => requests.get('/info/hot');

// 媒体聚焦
export const reqgetReportInfo = (pageNum, pageSize) => {
  // 使用反引号（`）来定义模板字符串，并可以在其中嵌入变量  
  return requests.get(`/report/table?pageNum=${pageNum}&pageSize=${pageSize}`);
};

// 媒体热点
export const reqgetHotReportInfo = () => requests.get('/report/hot');


// 社会责任
export const reqgetSocialResp = () => requests.get('article/sustainable/17');

// 安全环保
export const reqgetEnvirPro = () => requests.get('article/sustainable/18');

// 节能低碳
export const reqgetEnergySave = () => requests.get('article/sustainable/19');

// 清洁生产
export const reqgetCleaner = () => requests.get('article/sustainable/20');

// 人才理念
export const reqgetTalentConcept = () => requests.get('article/recruit/21');



// WEBPACK FOOTER //
// ./src/api/index.js